import PropTypes from 'prop-types';
import LoadingSkeleton from '../LoadingSkeleton';
import './TextInput.scss';

function TextInput({
  loading = false,
  autoComplete = 'off',
  requestPasswordManagerIgnore = true,
  className = '',
  labelClassName = '',
  inputClassName = '',
  descriptionClassName = '',
  errorClassName = '',
  tabIndex = 0,
  isValid = true,
  disabled = false,
  displayOnly = false,
  horizontal = false,
  type = 'text',
  name = '',
  label = '',
  placeholder = '',
  value = '',
  description = '',
  error = '',
  onClick = () => {},
  onChange = () => {},
  onBlur = () => {},
  left = null,
  right = null,
  autoFocus = false,
}) {
  const isInvalid = !isValid || error;
  // When displayOnly is true, ignore disabled prop
  const isDisabled = displayOnly ? false : disabled;
  const inputProps = requestPasswordManagerIgnore ? { 'data-1p-ignore': true } : null;

  if (loading) {
    return (
      <div className={`TextInput ${className}`}>
        {label && <LoadingSkeleton className="TextInput-labelText--loader" />}
        <LoadingSkeleton className="TextInput-input--loader" />
        {description && <LoadingSkeleton className="TextInput-description--loader" />}
        {error && <LoadingSkeleton className="TextInput-description--loader" />}
      </div>
    );
  }

  return (
    <div
      className={`TextInput ${isDisabled ? 'TextInput--disabled' : ''} 
      ${horizontal ? 'TextInput--horizontal' : ''} 
      ${displayOnly ? 'TextInput--displayOnly' : ''}
      ${className}`}
      onClick={onClick}
    >
      {label && (
        <label className={`TextInput-labelText ${isInvalid ? 'TextInput-labelText--error' : ''} ${labelClassName}`}>
          {label}
        </label>
      )}
      <div className="TextInput-inputWrapper">
        {left}
        {displayOnly ? (
          <div className={`TextInput-displayValue ${inputClassName}`}>{(value ?? placeholder) || '—'}</div>
        ) : (
          <input
            type={type}
            {...inputProps}
            autoComplete={autoComplete} // Typically don't want fields on the site to have auto-complete
            className={`TextInput-input ${isInvalid ? 'TextInput-input--error' : ''} ${inputClassName}`}
            tabIndex={tabIndex}
            disabled={isDisabled}
            name={name}
            placeholder={placeholder}
            value={value ?? ''}
            onChange={onChange}
            onBlur={onBlur}
            autoFocus={autoFocus}
          />
        )}
        {right}
      </div>

      {description && <div className={`TextInput-description ${descriptionClassName}`}>{description}</div>}

      <div className={`TextInput-errors ${!isInvalid ? 'TextInput-errors--empty' : ''} ${errorClassName}`}>
        {isInvalid && error}
      </div>
    </div>
  );
}

TextInput.propTypes = {
  loading: PropTypes.bool,
  autoComplete: PropTypes.string,
  inputRef: PropTypes.object,
  className: PropTypes.string,
  errorClassName: PropTypes.string,
  labelClassName: PropTypes.string,
  inputClassName: PropTypes.string,
  descriptionClassName: PropTypes.string,
  errorsClassName: PropTypes.string,
  tabIndex: PropTypes.number,
  isValid: PropTypes.bool,
  disabled: PropTypes.bool,
  displayOnly: PropTypes.bool,
  horizontal: PropTypes.bool,
  name: PropTypes.string,
  type: PropTypes.string,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  description: PropTypes.string,
  onClick: PropTypes.func,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  left: PropTypes.node,
  right: PropTypes.node,
  error: PropTypes.string,
  autoFocus: PropTypes.bool,
  requestPasswordManagerIgnore: PropTypes.bool,
};

export default TextInput;
